import React from 'react';
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend } from 'chart.js';

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

const ComparativeChart = ({ data, category }) => {
  // Fonction pour obtenir la couleur en fonction de la catégorie
  const getCategoryColor = (category) => {
    switch (category) {
      case 'Appels':
        return 'rgba(74, 214, 135, 1)'; // Couleur pour les appels
      case 'Internet':
        return 'rgba(11, 119, 255, 1)'; // Couleur pour Internet
      case 'SMS':
        return 'rgba(255, 206, 86, 1)'; // Couleur pour les SMS
      default:
        return 'rgba(75, 192, 192, 1)'; // Couleur par défaut
    }
  };

  const chartData = {
    labels: data.map(item => item.operator),
    datasets: [{
      label: category,
      data: data.map(item => item.scores.find(score => score.category === category).score),
      backgroundColor: getCategoryColor(category),
      borderColor: getCategoryColor(category).replace('0.6', '1'), // Couleur de la bordure
      borderWidth: 1,
    }],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false, // Permet d'ajuster la taille du graphique
    plugins: {
      legend: { position: 'top' },
      title: { display: true, text: `Importance des offres ${category}` },
    },
    scales: {
      y: {
        beginAtZero: true,
        title: {
          display: true,
          text: 'Score d\'importance',
          font: { size: 14 }
        }
      },
      x: {
        title: {
          display: true,
          text: 'Opérateurs',
          font: { size: 14 }
        },
        ticks: {
          autoSkip: true,
          maxTicksLimit: 5 // Limite le nombre de ticks sur l'axe X
        }
      }
    }
  };

  return (
    <div className="h-[60vh]"> {/* Ajuster la hauteur du conteneur */}
      <Bar data={chartData} options={options} />
    </div>
  );
};

export default ComparativeChart;